import { render, staticRenderFns } from "./AlertListBase.vue?vue&type=template&id=081a5284&scoped=true"
import script from "./AlertListBase.vue?vue&type=script&lang=js"
export * from "./AlertListBase.vue?vue&type=script&lang=js"
import style0 from "./AlertListBase.vue?vue&type=style&index=0&id=081a5284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081a5284",
  null
  
)

export default component.exports